import axios from "axios";
import { API } from "../shared/api/Api";

const EntityService = {
  // Get All entites
  getAllEnties: async (token, endpoint, params) => {
    try {
      const response = await axios.get(`${endpoint}`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      });
      return response;
    } catch (error) {
      console.error("Error fetching entity:", error);
      throw error;
    }
  },

  // Get an entity by ID
  getEntity: async (token, endpoint, entityId) => {
    try {
      const response = await axios.get(`${endpoint}/${entityId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      });
      return response;
    } catch (error) {
      console.error("Error fetching entity:", error);
      throw error;
    }
  },

  // Add a new entity
  addEntity: async (token, endpoint, data) => {
    try {
      const response = await axios.post(endpoint, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      });
      return response;
    } catch (error) {
      console.error("Error adding entity:", error);
      throw error;
    }
  },

  // Update an entity
  updateEntity: async (token, endpoint, entityId, data) => {
    try {
      const response = await axios.post(`${endpoint}/${entityId}`, data, {
        params: { _method: "PUT" },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      });
      return response;
    } catch (error) {
      console.error("Error updating entity:", error);
      throw error;
    }
  },

  // Delete an entity
  deleteEntity: async (token, endpoint, entityId) => {
    try {
      const response = await axios.delete(`${endpoint}/${entityId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      });
      return response;
    } catch (error) {
      console.error("Error deleting entity:", error);
      throw error;
    }
  },
};

export const addMaterial = async (formData, onUploadProgress, token) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    onUploadProgress,
  };

  try {
    const response = await axios.post(
      API.Materials.app_courses_materials_add,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    // return { success: false, error };
    throw error;
    // throw error.response?.data || error.message;
  }
};

export default EntityService;
